import { CourseSelectorComponent } from './setup/course-selector/course-selector.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScoreCardComponent } from './match/score-card/score-card.component';


const routes: Routes = [
  { path: 'course-select', component: CourseSelectorComponent },
  { path: 'score-card/:id', component: ScoreCardComponent },
  { path: '', redirectTo: '/course-select', pathMatch: 'full' },

  // {path: '**', component: **ERROR**}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
